export interface RenderNameWithSuffixProps {
  name: string;
  suffix?: string | number;
}

export const NameWithSuffix = ({ name, suffix }: RenderNameWithSuffixProps) => {
  return (
    <span className="flex items-center gap-1">
      <span>{name}</span>
      {suffix ? (
        <span className="text-gray-400 text-xs">({suffix})</span>
      ) : null}
    </span>
  );
};
